import { useBoolean } from "@/ui-kit";
import { useCallback, useState, useEffect } from "react";
import type { IInspector } from "@/types/users-inspectors";
import EditModal from "./EditModal";
import { AddressDetailsCard } from "@/components/profile-cards";

type IProps = {
  profile: IInspector;
};

const AddressDetails = ({ profile }: IProps) => {
  const [values, setValues] = useState<IInspector | null>(profile);

  useEffect(() => {
    if (profile) {
      setValues(profile);
    }
  }, [profile]);

  const updateValues = useCallback((updatedInspector: IInspector) => {
    setValues(updatedInspector);
  }, []);

  const {
    value: showEditModal,
    setTrue: openEditModal,
    setFalse: dismissEditModal,
  } = useBoolean(false);

  const currentProfile = values || profile;

  return (
    <>
      <AddressDetailsCard address={currentProfile.address} onEdit={openEditModal} />
      {showEditModal && (
        <EditModal
          inspector={currentProfile}
          onSave={updateValues}
          onDismiss={dismissEditModal}
        />
      )}
    </>
  );
};

export default AddressDetails;
